module.exports = __webpack_public_path__ + "img/itemDisplay2.72380673.webp";